<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <div class="text-right mb-3"></div>
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>

            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            <span> {{ (currentPage - 1) * perPage + row.index + 1 }} </span>
                        </template>
                        <template v-slot:cell(numero)="{ item }">
                            <span>{{ item.numero }}</span>
                            <br />
                            <span>{{ formatDate(item.createDate) }}</span>
                        </template>
                        <template v-slot:cell(nominativo)="{ item }">
                            <span class="sa-table-span-label-primary">{{ item.cognome }} {{ item.nome }}</span>
                            <span class="sa-table-span-label-secondary">{{ item.identificativo }}</span>
                        </template>
                        <template v-slot:cell(eta)="{ item }">
                            <span>{{ calcoloEta(item.dataNascita) }}</span>
                        </template>
                        <template v-slot:cell(sesso)="{ item }">
                            <span>{{ item.sesso }}</span>
                        </template>
                        <template v-slot:cell(email)="{ value }">
                            <span>{{ value }}</span>
                        </template>
                        <template v-slot:cell(camera)="{ item }">
                            <span>{{ item.camera }}</span>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Richiesta" variant="outline-secondary" @click="onClickView(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="eye" />
                                </b-button>
                                <b-button v-if="row.item.regime === 'RESIDENZIALE' && row.item.statoAttuale === 'ACCETTATO'" size="sm" v-b-tooltip.hover title="Ricovera Paziente" variant="outline-success" @click="onClickRicovera(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="bed" />
                                </b-button>
                                <b-button v-if="row.item.regime === 'DOMICILIARE' && row.item.statoAttuale === 'ACCETTATO'" size="sm" v-b-tooltip.hover title="Apri Cartella A.D.I. - Arruola Paziente" variant="outline-success" @click="onClickApriCartellaAdi(row.item)" class="mr-1 no-text">
                                    <i class="far fa-folder-open"></i>
                                </b-button>
                                <b-button v-if="row.item.regime === 'AMBULATORIALE' && row.item.statoAttuale === 'ACCETTATO'" size="sm" v-b-tooltip.hover title="Apri Cartella" variant="outline-blue" @click="onClickApriCartellaAmbulatoriale(row.item)" class="mr-1 no-text">
                                    <i class="far fa-folder-open"></i>
                                </b-button>
                                <b-button v-if="row.item.regime === 'SEMIRESIDENZIALE' && row.item.statoAttuale === 'ACCETTATO'" size="sm" v-b-tooltip.hover title="Apri Cartella" variant="outline-blue" @click="onClickApriCartellaSemiresidenziale(row.item)" class="mr-1 no-text">
                                    <i class="far fa-folder-open"></i>
                                </b-button>
                                <!--  <b-button size="sm" v-b-tooltip.hover title="PROVA" variant="outline-success" @click="onClickProva(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="edit" />
                                </b-button> -->
                                <b-button v-if="row.item.statoAttuale === 'ACCETTATO_ATTESA_CONSENSO'" size="sm" v-b-tooltip.hover title="Mancano i Consensi" variant="outline-danger" @click="onClickConsensiInfo(row.item, row.index, $event.target)" class="mr-1 no-text">
                                    <i class="fas fa-file-signature"></i>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Cancella Accettazione" variant="outline-danger" @click="onClickAnnullaAccetazione(row.item, row.index, $event.target)" class="mr-1 no-text">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <rsa-assegna-posto-letto-modal-edit-component ref="cmpAccettazionePostiLettoModalEdit" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" />
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaAssegnaPostoLettoModalEditComponent from "./RsaAssegnaPostoLettoModalEditComponent.vue";
export default {
    components: { RsaAssegnaPostoLettoModalEditComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            btnNuovaAccettazioneHidden: false,
            pathResource: "/rsaaccettazioni",
            linkedit: "/rsaaccettazione",
            pathResourceRicoveraPaziente: "/rsaaccettazioni/aggiornastato",
            pathResourceAnnullaAccettazione: "/rsaaccettazioni/aggiornastato",
            filtroAccettazione: {},
            items: [],
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Numero Cartella",
                    key: "numero",
                    sortable: true,
                },
                {
                    label: "Nominativo",
                    key: "nominativo",
                    sortable: true,
                },
                {
                    label: "Età",
                    key: "eta",
                },
                { label: "Numero telefono", key: "telefono" },
                {
                    label: "Email",
                    key: "email",
                },
                {
                    label: "Sesso",
                    key: "sesso",
                },
                {
                    label: "Camera",
                    key: "camera",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroAccettazione"]) {
                me.filtroAccettazione = JSON.parse(sessionStorage["filtroAccettazione"]);
            }

            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtroAccettazione.page = me.currentPage;
            me.filtroAccettazione.forPage = me.perPage;
            // if (me.filtroAccettazione.idPresidio) {
            me.$emit("beforeLoadData");
            axios
                .get(link, { params: me.filtroAccettazione })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
            // } else {
            //     this.$bvModal.msgBoxOk("Inserire Presidio", {
            //         title: "ATTENZIONE",
            //         size: "sm",
            //         okVariant: "outline-danger",
            //     });
            // }
        },
        onClickView(item) {
            let me = this;
            me.$router.push("/rsaaccettazione/view/" + item.id);
        },
        onClickRicovera(item) {
            let me = this;
            me.$refs.cmpAccettazionePostiLettoModalEdit.show(item);
        },
        onClickApriCartellaAmbulatoriale(item) {
            let jsonStato = { idAccetazione: item.id, stato: "ACCETTATO_AMBULATORIALE" };
            this.ricovera(jsonStato);
        },
        onClickApriCartellaSemiresidenziale(item) {
            let jsonStato = { idAccetazione: item.id, stato: "ACCETTATO_SEMIRESIDENZIALE" };
            this.ricovera(jsonStato);
        },
        onClickApriCartellaAdi(item) {
            let jsonStato = { idAccetazione: item.id, stato: "ACCETTATO_ADI" };
            this.ricovera(jsonStato);
        },
        onClickProva(item) {
            let me = this;
            me.ricovera(item);
        },
        ricovera(jsonStato) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRicoveraPaziente;
            axios
                .post(link, jsonStato)
                .then(() => {
                    me.loadData();
                })
                .catch((error) => {
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    me.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        annullaAccettazione(id) {
            let me = this;
            let accettazioneStato = {
                idAccetazione: id,
                stato: "CANCELLATO",
            };
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAnnullaAccettazione; /* + "/" + item.id */
            axios
                .post(link, JSON.stringify(accettazioneStato))
                .then(() => {
                    me.loadData();
                    me.$bvToast.toast("Cancellazione avvenuta con successo", {
                        title: "Successo",
                        variant: "success",
                        solid: true,
                    });
                })
                .catch((e) => {
                    console.log(e);
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore durante la cancellazione", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        onClickAnnullaAccetazione(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Cancella accettazione",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.annullaAccettazione(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
            me.loadData();
        },
        onBeforeLoadData() {
            let me = this;
            me.$emit("beforeLoadData");
        },
        resetList() {
            let me = this;
            me.items = [];
        },
        onClickConsensiInfo() {
            this.$bvModal.msgBoxOk("Ci sono dei consensi OBBLIGATORI da firmare per poter procedere al ricovero o arruolamento", {
                title: ["ATTENZIONE!"],
                size: "sm",
                okVariant: "outline-danger",
                headerClass: "sa-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
            });
        },
    },
};
</script>
<style></style>
